(function(){
  'use strict';

  var desktopTrigger=document.querySelector('[data-nn-shop-trigger]');
  var desktopLayer=document.querySelector('[data-nn-shop-drawer]');
  var desktopPanel=desktopLayer&&desktopLayer.querySelector('[data-nn-shop-panel]');
  var mobileTrigger=document.querySelector('[data-nn-mobile-trigger]');
  var mobileLabel=mobileTrigger&&mobileTrigger.querySelector('[data-nn-menu-label]');
  var mobileLayer=document.querySelector('[data-nn-mobile-menu]');
  var mobilePanel=mobileLayer&&mobileLayer.querySelector('[data-nn-mobile-panel]');
  var desktopQuery=window.matchMedia('(min-width: 1121px)');
  var hoverQuery=window.matchMedia('(hover: hover) and (pointer: fine)');
  var lastFocus=null;
  var hoverOpenTimer=null;
  var hoverCloseTimer=null;

  function focusable(container){
    if(!container)return [];
    return Array.prototype.slice.call(container.querySelectorAll('a[href]:not([tabindex="-1"]),button:not([disabled]):not([tabindex="-1"]),input:not([disabled]):not([type="hidden"]):not([tabindex="-1"]),select:not([disabled]):not([tabindex="-1"]),textarea:not([disabled]):not([tabindex="-1"]),summary,[tabindex]:not([tabindex="-1"])')).filter(function(node){return !node.hidden&&node.getClientRects().length>0;});
  }

  function setPageInert(active){
    ['#MainContent','.nn-footer','[data-nn-header]','.nn-announce'].forEach(function(selector){
      var node=document.querySelector(selector);
      if(!node)return;
      if(active){
        if(!node.inert){node.setAttribute('data-nn-menu-inerted','');node.inert=true;}
        if(!node.hasAttribute('aria-hidden')){node.setAttribute('data-nn-menu-aria-hidden','');node.setAttribute('aria-hidden','true');}
      }else{
        if(node.hasAttribute('data-nn-menu-inerted')){node.inert=false;node.removeAttribute('data-nn-menu-inerted');}
        if(node.hasAttribute('data-nn-menu-aria-hidden')){node.removeAttribute('aria-hidden');node.removeAttribute('data-nn-menu-aria-hidden');}
      }
    });
  }

  function isDesktopOpen(){return Boolean(desktopLayer&&!desktopLayer.hidden&&desktopLayer.classList.contains('is-open'));}
  function isMobileOpen(){return Boolean(mobileLayer&&!mobileLayer.hidden&&mobileLayer.classList.contains('is-open'));}

  function closeDesktop(restoreFocus){
    if(!desktopLayer||desktopLayer.hidden)return;
    var focusWasInside=Boolean(desktopPanel&&desktopPanel.contains(document.activeElement));
    var restoreTarget=focusWasInside?desktopTrigger:lastFocus;
    window.clearTimeout(hoverOpenTimer);
    window.clearTimeout(hoverCloseTimer);
    desktopLayer.classList.remove('is-open');
    if(desktopTrigger)desktopTrigger.setAttribute('aria-expanded','false');
    window.setTimeout(function(){if(!desktopLayer.classList.contains('is-open'))desktopLayer.hidden=true;},390);
    if((restoreFocus!==false||focusWasInside)&&restoreTarget&&typeof restoreTarget.focus==='function')restoreTarget.focus();
    lastFocus=null;
  }

  function openDesktop(moveFocus){
    if(!desktopLayer||!desktopTrigger||!desktopQuery.matches||isDesktopOpen())return;
    closeMobile(false);
    lastFocus=document.activeElement;
    desktopLayer.hidden=false;
    desktopTrigger.setAttribute('aria-expanded','true');
    window.requestAnimationFrame(function(){
      desktopLayer.classList.add('is-open');
      if(moveFocus){
        var first=focusable(desktopPanel)[0];
        if(first)first.focus();
        else if(desktopPanel)desktopPanel.focus();
      }
    });
  }

  function closeMobile(restoreFocus){
    if(!mobileLayer||mobileLayer.hidden)return;
    if(window.NNSearch&&window.NNSearch.resetInline)window.NNSearch.resetInline();
    mobileLayer.classList.remove('is-open');
    if(mobileTrigger){mobileTrigger.setAttribute('aria-expanded','false');mobileTrigger.setAttribute('aria-label','Open menu');}
    if(mobileLabel)mobileLabel.textContent='Open menu';
    document.body.classList.remove('nn-lock','nn-menu-open');
    setPageInert(false);
    window.setTimeout(function(){if(!mobileLayer.classList.contains('is-open'))mobileLayer.hidden=true;},430);
    if(restoreFocus!==false&&lastFocus&&typeof lastFocus.focus==='function')lastFocus.focus();
    lastFocus=null;
  }

  function openMobile(){
    if(!mobileLayer||!mobileTrigger||desktopQuery.matches)return;
    closeDesktop(false);
    lastFocus=document.activeElement;
    mobileLayer.hidden=false;
    mobileTrigger.setAttribute('aria-expanded','true');
    mobileTrigger.setAttribute('aria-label','Close menu');
    if(mobileLabel)mobileLabel.textContent='Close menu';
    document.body.classList.add('nn-lock','nn-menu-open');
    setPageInert(true);
    window.requestAnimationFrame(function(){
      mobileLayer.classList.add('is-open');
      var first=mobilePanel&&mobilePanel.querySelector('[data-nn-mobile-close]');
      if(first)first.focus();
      else if(mobilePanel)mobilePanel.focus();
    });
  }

  function closeAll(restoreFocus){
    if(isDesktopOpen())closeDesktop(restoreFocus);
    if(isMobileOpen())closeMobile(restoreFocus);
  }

  function trapFocus(event,container){
    if(event.key!=='Tab')return;
    var items=focusable(container);
    if(!items.length){event.preventDefault();container.focus();return;}
    var first=items[0];
    var last=items[items.length-1];
    if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
  }

  if(desktopTrigger&&desktopLayer){
    desktopTrigger.addEventListener('click',function(){
      window.clearTimeout(hoverOpenTimer);
      window.clearTimeout(hoverCloseTimer);
      isDesktopOpen()?closeDesktop(true):openDesktop(true);
    });
    desktopTrigger.addEventListener('mouseenter',function(){
      if(!hoverQuery.matches)return;
      window.clearTimeout(hoverCloseTimer);
      hoverOpenTimer=window.setTimeout(function(){openDesktop(false);},110);
    });
    desktopTrigger.addEventListener('mouseleave',function(){
      if(!hoverQuery.matches)return;
      window.clearTimeout(hoverOpenTimer);
      hoverCloseTimer=window.setTimeout(function(){if(!desktopLayer.matches(':hover'))closeDesktop(false);},240);
    });
    desktopLayer.addEventListener('mouseenter',function(){window.clearTimeout(hoverCloseTimer);});
    desktopLayer.addEventListener('mouseleave',function(event){
      if(!hoverQuery.matches||desktopPanel&&desktopPanel.contains(event.relatedTarget))return;
      hoverCloseTimer=window.setTimeout(function(){if(!desktopTrigger.matches(':hover'))closeDesktop(false);},240);
    });
    desktopLayer.querySelectorAll('[data-nn-shop-close]').forEach(function(button){button.addEventListener('click',function(){closeDesktop(true);});});
  }

  if(mobileTrigger&&mobileLayer){
    mobileTrigger.addEventListener('click',function(){isMobileOpen()?closeMobile(true):openMobile();});
    mobileLayer.querySelectorAll('[data-nn-mobile-close]').forEach(function(button){button.addEventListener('click',function(){closeMobile(true);});});
    mobileLayer.querySelectorAll('details').forEach(function(detail){
      detail.addEventListener('toggle',function(){
        if(!detail.open)return;
        mobileLayer.querySelectorAll('details').forEach(function(other){if(other!==detail)other.open=false;});
      });
    });
  }

  document.addEventListener('click',function(event){
    if(event.target.closest('[data-nn-menu-link]'))closeAll(false);
    if(isDesktopOpen()&&!desktopLayer.contains(event.target)&&!desktopTrigger.contains(event.target))closeDesktop(false);
  });

  document.addEventListener('keydown',function(event){
    if(event.key==='Escape'&&(isDesktopOpen()||isMobileOpen())){
      event.preventDefault();
      closeAll(true);
      return;
    }
    if(isMobileOpen())trapFocus(event,mobilePanel);
    else if(isDesktopOpen())trapFocus(event,desktopPanel);
  });

  var onBreakpoint=function(){closeAll(false);};
  if(desktopQuery.addEventListener)desktopQuery.addEventListener('change',onBreakpoint);
  else desktopQuery.addListener(onBreakpoint);

  window.NNMenu={
    close:function(restoreFocus){closeAll(restoreFocus);},
    open:function(){desktopQuery.matches?openDesktop(true):openMobile();},
    openShop:function(){desktopQuery.matches?openDesktop(true):openMobile();}
  };
})();
